import { PageTypes, SummaryPageTypes } from '@shared/types';
import { ResultFieldProperties } from '@shared/types/ResultFieldProperties';
export const resultValueNotAppliable = 'n/a';
export const getUnModifiedFields = (pageType) => {
    const commonFields = [ResultFieldProperties.companyName, ResultFieldProperties.shippingDate];
    switch (pageType) {
        case PageTypes.tags:
        case PageTypes.delivery:
            return [
                ...commonFields,
                ResultFieldProperties.location,
                ResultFieldProperties.materialType,
                ResultFieldProperties.materialName,
                ResultFieldProperties.customLength,
                ResultFieldProperties.customQuantities,
                ResultFieldProperties.totalQuantities,
                ResultFieldProperties.weight
            ];
        case PageTypes.processing_tags:
            return [
                ResultFieldProperties.certificateNumber,
                ResultFieldProperties.companyName,
                ResultFieldProperties.weight
            ];
        case PageTypes.processing_sheet:
            return [
                ResultFieldProperties.certificateNumber,
                ResultFieldProperties.companyName,
                ResultFieldProperties.shippingDate,
                ResultFieldProperties.weight
            ];
        case SummaryPageTypes.summary_list:
            return [
                ResultFieldProperties.customLength,
                ResultFieldProperties.customQuantities,
                ResultFieldProperties.totalQuantities,
                ResultFieldProperties.weight,
                ResultFieldProperties.quantities
            ];
        case PageTypes.certificate:
            return [
                ResultFieldProperties.customLength,
                ResultFieldProperties.customQuantities,
                ResultFieldProperties.totalQuantities
            ];
        default:
            return commonFields;
    }
};
